import TimeInput2 from 'src/components/ui/time-input2/TimeInput2';
import { InputProps } from '../OdfjellInputComponent';

const TimeInputComponent: React.FC<Partial<InputProps>> = ({ value, onTimeInputChange }: Partial<InputProps>) => {
    const getTimeStringFromNumber = () => {
        const convertedNumber = Number(value);
        const hours = Math.trunc(convertedNumber);
        const minutes = (convertedNumber - hours) * 60;

        const hoursStr = hours.toString().padStart(2, '0');
        const minutesStr = minutes.toFixed(0).toString().padStart(2, '0');
        return hoursStr + ':' + minutesStr;
    };

    if (value && value > 0) {
        return (
            <TimeInput2
                value={getTimeStringFromNumber()}
                onChange={(durationString) => onTimeInputChange({ hours: value, durationString })}
                isDuration={true}
            />
        );
    }
    return <TimeInput2 value={'00:00'} onChange={(durationString) => onTimeInputChange({ hours: value, durationString })} isDuration={true} />;
};

export default TimeInputComponent;
